import { Articles } from "../../data/models/article";

const AuthorCard = ({ article }: { article: Articles }) => {
  return (
    <div className="mx-[16px] mt-[32px] flex max-w-[870px] flex-col justify-between rounded-[24px] bg-[#FFF3ED] px-[20px] py-[22px] lg:mx-auto lg:flex-row">
      <div className="flex flex-1 flex-row gap-[16px]">
        {article?.author_avatar && (
          <img
            src={`${process.env.REACT_APP_STRAPI_URL}${article.author_avatar.url}`}
            alt={"author avatar"}
            className="h-[56px] w-[56px] rounded-full object-cover"
          />
        )}
        <div className="flex flex-1 flex-col gap-[6px]">
          <p className="font-inter text-[24px] font-medium leading-[100%] tracking-[-0.01em] text-[#131313]">
            {article?.author?.charAt(0).toUpperCase() +
              article?.author?.slice(1)}
          </p>
          <p className="text-[16px] font-normal leading-[140%] tracking-[0%] text-[#5A5A59]">
            {article?.author_bio}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthorCard;
